import {
  Component,
  ChangeDetectionStrategy,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'elm-app-header-actions',
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class HeaderActionsComponent {}

@Component({
  selector: 'elm-app-header-content',
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class HeaderContentComponent {}

@Component({
  selector: 'elm-app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
  host: {
    class: 'elm-app451-container-full'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {}
